import React from 'react';
import DialogHeaderWithClose from '../../../components/basic/DialogHeaderWithClose';
import { DialogInput } from '../../../components/advanced';


/**
 * Dialog content can be scrollable.
 */

class OrderDetailsDialog extends React.Component {
    state = {
        open: false
    };

    render() {
        const p = this.props;
        let dialogStyles = {
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: '1500px'
        };
        return (
            <div>
                <DialogInput
                    title={<DialogHeaderWithClose text={p.title} handleClose={()=>p.handleClose()} />}
                    open={p.open}
                    actions={p.actions}
                    titleStyle={p.titleStyle}
                    modal={p.model}
                    style={p.style}
                    autoScrollBodyContent
                    className={p.className}
                >
                    {p.children}
                </DialogInput>
            </div>
        );
    }
}

export default OrderDetailsDialog;
